module.exports = __webpack_public_path__ + "static/img/bronze.4e53363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/bronze.png
// module id = +glU
// module chunks = 2